import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../login-service'
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidators } from '../register/custom-validators';
@Component({
    selector: 'initiatorchange-app',
    templateUrl: 'initiatorchangepwd.component.html',
    providers:[LoginService]
})

export class InitiatorChangePwdComponent implements OnInit {
    currentPassword:string;
    newPassword:string;
    confirmPassword:string
    userID: string;
    tempUsersList: any;
    usersList: any;
    registerForm: FormGroup;
    submitted:boolean=false;
    errormsg:string;
    matched:boolean=false;
    usertype:string;
    subject: string;
    description: string;
    constructor(private loginServie:LoginService,private formBuilder: FormBuilder,private router:Router) { 
        this.userID=localStorage.getItem('USERID');
        this.usertype=localStorage.getItem('userType');
    }

    ngOnInit() {
        this.GetUsers();
        this.registerForm = this.formBuilder.group({
            currentPassword: ['', [Validators.required]],
             newPassword: ['', [Validators.required, Validators.minLength(8),
                CustomValidators.patternValidator(/\d/, { hasNumber: true }),
                CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
                CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
                // CustomValidators.patternValidator(/[ [!@#$%^&*()_+-=[]{};':"|,.<>/?]/](<mailto:!@#$%^&*()_+-=[]{};':"|,.<>/?]/>), { hasSpecialCharacters: true })
             ]],
             confirmPassword: ['', [Validators.required]]
        }, { 
          validator: this.ConfirmedValidator('newPassword', 'confirmPassword')
        }
        );
     }
     ConfirmedValidator(controlName: string, matchingControlName: string){
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ confirmedValidator: true });
            } else {
                matchingControl.setErrors(null);
            }
        }
    }
    get f() { return this.registerForm.controls; }
     GetUsers(){
        this.loginServie.GetUsers(this.usertype).subscribe(data=>{
            data = JSON.parse(data['_body']);
            this.tempUsersList=JSON.parse(JSON.stringify(data));

            let filterUser=this.tempUsersList.filter(x=>x.id.toString()==this.userID.toString());
            if(filterUser.length>0){
                this.usersList=filterUser[0];
            }
        })
    
     }
     checkCurrentpass(){
this.currentPassword=this.registerForm.value.currentPassword;

if(this.usersList.password.toString()===this.currentPassword.toString()){
    this.errormsg="";
    this.matched=true
}
else{
this.errormsg="This does not match your current password";
this.matched=false;
}

     }
     ResetPassword(){
        this.submitted = true;
         this.newPassword=this.registerForm.value.newPassword;
         
         const json={
            emailparm:this.usersList.email,
            useridparm:this.usersList.id,
            passwordparm:this.newPassword
         }
         this.subject="Password Change alert"
         this.description="Your Password has been changed"
if(this.registerForm.valid && this.matched){
  
         this.loginServie.ResetPassword(json).subscribe(data=>{
            
             Swal.fire("Password changed successfully");
             this.registerForm.value.currentPassword="";
             this.registerForm.value.newPassword="";
             this.registerForm.value.confirmPassword="";
             this.loginServie.SendMail(this.usersList.email,this.subject,this.description).subscribe(data=>{
              
                  this.loginServie.showSuccess("Mail Send Successfuly","");
                  
              })
         })
        }
        else{
            return;
        }
     }
     Cancel(){
        
         if(this.usertype=='1'){
             this.router.navigate(['/initatorcollabo/0/0']);
         }
         else if(this.usertype=='2'){
             this.router.navigate(['/collabo']);
         }
     }
}
